import(/* webpackMode: "eager" */ "/app/src/app/home/[lang]/contact-us/ContactUsClient.tsx")